import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetNeighborhoodsDentalGuide,
	GetNeighborhoodsDentalGuideModel,
	GetNeighborhoodsDentalGuideParams,
} from 'domain/usecases';

export class RemoteGetNeighborhoodsDentalGuide implements GetNeighborhoodsDentalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetNeighborhoodsDentalGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetNeighborhoodsDentalGuideParams): Promise<GetNeighborhoodsDentalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
